import { Logger, LoggerService } from '@Shared/logger';
import { Screen } from './screen.base';
import { OptionsModule } from '@Modules/options_module';
import { UIModule } from '@Modules/ui_module/ui.module';
import { Alert } from '@Modules/ui_module/components/alert/alert.component';

export class EntitlementCheckScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger('EntitlementCheckScreen');

  constructor() {
    super();
    this.Logger.trace('****  CTOR ****');

    this._html = UIModule.HTML.entitlementCheck;
    this._screenOptions = OptionsModule.Options.ui.screens.entitlementCheck;
    this._alert = new Alert();
  }

  show(): void {
    super.show();
    this.Logger.trace('show called');
  }
}
